/**
 * @desc 发运报告分页
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.fulfillShipmentPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/fulfillShipmentPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
